import React from "react";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";
import { Button, Select } from "../ui";

interface ListPagerProps extends WithTranslation {
  changePage?: (page: number) => void;
  changePageSize?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  page?: number;
  pageNumber?: number;
  pageSize?: number;
  pageSizeId?: string;
  pageSizeOptions?: number[];
  summary?: React.ReactNode;
}

function ListPager({
  t,
  changePage,
  changePageSize,
  className,
  page,
  pageNumber,
  pageSize,
  pageSizeId,
  pageSizeOptions,
  summary,
}: ListPagerProps) {
  const options = pageSizeOptions || [10, 20, 50];
  const hasPager = Boolean(changePage && page && pageNumber);
  const hasPageSize = Boolean(changePageSize && pageSize);
  const pageSizeIdResolved = pageSizeId || "elementsByPage";

  return (
    <section className={`ListPager${className ? ` ${className}` : ""}`}>
      {summary ? <div className="ListPager-summary">{summary}</div> : null}
      {hasPageSize ? (
        <div className="ListPager-pageSizeChanger">
          <label htmlFor={pageSizeIdResolved}>{t("common.list.label_display")}</label>
          <Select
            className="Select"
            onChange={changePageSize}
            value={pageSize}
            id={pageSizeIdResolved}
            options={options.map((sz) => ({
              value: sz,
              label: sz,
            }))}
          />
        </div>
      ) : null}
      {hasPager && changePage && page ? (
        <div className="ListPager-pager Pager">
          <Button
            variant="secondary"
            className="Button"
            onClick={() => changePage(page - 1)}
            disabled={page <= 1}
          >
            {t("common.list.label_page_back")}
          </Button>
          <label aria-hidden="true" className="Pager-pageIndicator">
            {t("common.list.label_page", {
              currentPage: page,
              pages: pageNumber,
            })}
          </label>
          <Button
            variant="secondary"
            className="Button"
            onClick={() => changePage(page + 1)}
            disabled={(page || 0) >= (pageNumber || 0)}
          >
            {t("common.list.label_page_next")}
          </Button>
        </div>
      ) : null}
    </section>
  );
}

export default compose(withTranslation())(ListPager);
